"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveSecondaryButton = exports.movePrimaryButton = exports.TRIP_TYPES = exports.TRANSLATION = exports.THEMES = exports.STYLES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var THEMES = {
  CLASSIC: 'AIRASIA_CLASSIC',
  MOVE: 'AIRASIA_MOVE'
};
exports.THEMES = THEMES;
var movePrimaryButton = {
  true: {
    backgroundColor: 'primary',
    border: 'charcoalGrey',
    color: 'secondary',
    hoverBackgroundColor: 'primaryDark',
    hoverColor: 'secondary'
  },
  false: {
    backgroundColor: 'primary',
    border: null,
    color: 'default',
    hoverBackgroundColor: 'primaryDark',
    hoverColor: 'default'
  }
};
exports.movePrimaryButton = movePrimaryButton;
var moveSecondaryButton = {
  true: {
    backgroundColor: 'default',
    border: 'secondary',
    color: 'secondary',
    hoverBackgroundColor: 'greyLighter',
    hoverColor: 'secondary'
  },
  false: {
    backgroundColor: 'default',
    border: 'primary',
    color: 'primary',
    hoverBackgroundColor: 'greyLighter',
    hoverColor: 'primary'
  }
};
exports.moveSecondaryButton = moveSecondaryButton;
var TRANSLATION = {
  ctaText: 'Select',
  guest: 'for {count} guests',
  percentageDiscount: '{percent}% OFF',
  details: 'Details'
};
exports.TRANSLATION = TRANSLATION;
var TRIP_TYPES = {
  roundtrip: 'roundtrip',
  oneway: 'oneway',
  multicity: 'multicity'
};
exports.TRIP_TYPES = TRIP_TYPES;

var STYLES = _objectSpread(_objectSpread({}, Object.keys(_theme.default.fontSize).reduce(function (obj, val) {
  return _objectSpread(_objectSpread({}, obj), {}, (0, _defineProperty2.default)({}, val, val));
}, {})), Object.keys(_theme.default.colors).reduce(function (obj, val) {
  return _objectSpread(_objectSpread({}, obj), {}, (0, _defineProperty2.default)({}, val, val));
}, {}));

exports.STYLES = STYLES;